import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

import FormSelect from '../../../components/form/FormSelect';
import FormTextarea from '../../../components/form/FormTextarea';

import { processAllOptionGet } from '../../../store/slices/tenantSlices/dailyReportSlice';
import {
  whatsappRedirectMessageAdd,
  whatsappRedirectMessageUpdate
} from '../../../store/slices/tenantSlices/configurationSlice';

const AddEditWhatsappRedirectMessageModal = ({
  isOpen,
  onCloseClick,
  isEdit = false,
  editRecord = null
}) => {
  const dispatch = useDispatch();

  const [processOptions, setProcessOptions] = useState([]);

  const initialValues = {
    process_id: '',
    message: ''
  };

  const validationSchema = Yup.object({
    process_id: Yup.string().required('process is required'),
    message: Yup.string().trim().required('message is required')
  });

  const onSubmit = async () => {
    try {
      const payload = {
        process_id: Number(values.process_id),
        message: values.message
      };

      let response;
      if (isEdit) {
        response = await dispatch(
          whatsappRedirectMessageUpdate({ ...payload, id: editRecord.id })
        ).unwrap();
      } else {
        response = await dispatch(whatsappRedirectMessageAdd(payload)).unwrap();
      }

      if (response && response?.message) {
        toast.success(`Record ${isEdit ? 'Updated' : 'Added'} Successfully`);
        onCloseClick(true);
        resetForm();
      } else {
        toast.error(response?.error || 'Something went wrong');
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    resetForm,
    setValues
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  const getProcessOption = async () => {
    try {
      const response = await dispatch(processAllOptionGet()).unwrap();
      if (response && response.data) {
        const options = response.data.map((val) => ({
          label: val.name,
          value: val.id
        }));
        setProcessOptions(options);
      } else {
        setProcessOptions([]);
      }
    } catch (error) {
      setProcessOptions([]);
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getProcessOption();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isEdit) {
      setValues({
        ...values,
        process_id: Number(editRecord?.process_id),
        message: editRecord?.message || ''
      });
    }
  }, [editRecord]);

  return (
    <Modal isOpen={isOpen} size="lg" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">
          {isEdit ? 'Edit Whatsapp Redirect Message' : 'Add Whatsapp Redirect Message'}
        </div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="whatsapp-redirect-message" onSubmit={handleSubmit}>
          <Row>
            <Col lg="6">
              <FormSelect
                name="process_id"
                label="Process"
                placeholder="Select Process"
                value={values.process_id}
                options={processOptions}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
                menuPlacement="bottom"
              />
            </Col>
            <Col lg="12">
              <FormTextarea
                name="message"
                label="Message"
                placeholder="Enter redirect message"
                value={values.message}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
                rows={3}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onCloseClick();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button
          form="whatsapp-redirect-message"
          type="submit"
          className="px-5 bg-primary border-primary">
          {isEdit ? 'Update' : 'Save'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddEditWhatsappRedirectMessageModal.propTypes = {
  isOpen: PropTypes.bool,
  isEdit: PropTypes.bool,
  onCloseClick: PropTypes.func,
  editRecord: PropTypes.any
};

export default AddEditWhatsappRedirectMessageModal;
